import { ContentSections } from "@tiicker/util/lib/contentful/helpers";
import { PageSection } from "@tiicker/util/lib/contentful/types";
import { Entry } from "contentful";
import React from "react";
import styles from "./NewsCallToAction.module.scss";
import NewsCTACard from "./NewsCTACard";

type Props = {
  callToAction: Entry<PageSection>;
  contentSections: ContentSections;
};

const NewsCallToAction = (props: Props) => {
  const contentSections =
    props.contentSections.sections[props.callToAction.sys.id];

  return (
    <div className={styles.container}>
      {contentSections.map((section) => (
        <NewsCTACard section={section} cardClassName={styles.card} />
      ))}
    </div>
  );
};

export default NewsCallToAction;
